import { FETCH_BOOKINGS_SUCCESS } from '@redux/bookings';
import type { Track } from '@typings/analytics';
import type { Dispatch } from '@typings/redux';
import type { Booking } from '@typings/redux/bookings';
import WeddingSDK from '@xo-union/sdk-weddings';
import { useCallback, useMemo } from 'react';
import { useTrackBookVendor } from './use-track-book-vendor';

export const useBookVendor = (
	dispatch: Dispatch,
	vendor: Vendor.Decorated | null,
	memberId: string,
	sessionToken: string | null,
	track: Track,
	onBookSuccess?: () => void,
) => {
	const weddingSdk = new WeddingSDK({
		apiKey: process.env.WEDDINGS_API_KEY as string,
		membershipSessionToken: sessionToken as string,
	});
	const trackBookVendor = useTrackBookVendor(
		track,
		true,
		vendor as Vendor.Decorated,
	);

	const upsertPayload = useMemo(
		() => ({
			booking: {
				member_id: memberId,
				vendor_profile_id: vendor?.id,
				category_code: vendor?.categoryCode,
				source: 'book_vendor_modal',
				vendor_name: vendor?.name,
				address_components: {
					local_vendor: {
						address1: vendor?.address.address,
						city: vendor?.address.city,
						state: vendor?.address.state,
						postalCode: vendor?.address.postalCode,
						isPublic: vendor?.address.isPublic,
					},
				},
			},
		}),
		[memberId, vendor],
	);

	return useCallback(
		async (bookings: Booking[], vendorFoundOnTk?: string) => {
			return weddingSdk.upsertBooking(upsertPayload).then((response) => {
				if (response.body.booking) {
					dispatch({
						type: FETCH_BOOKINGS_SUCCESS,
						bookings: [
							...(bookings || []),
							{
								bookingId: response.body.booking.id,
								vendorId: response.body.booking.vendor_profile_id,
							},
						],
					});
					trackBookVendor(vendorFoundOnTk);
					onBookSuccess?.();
					return true;
				}
				return false;
			});
		},
		[weddingSdk, dispatch, upsertPayload, trackBookVendor, onBookSuccess],
	);
};
